<template>
  <div id="bannerTop" :class="{active: topShow}">
    <section class="header-warp">
      <div class="logo">
        <a href="/">
          <span class="logoImg"></span>
        </a>
      </div>
      <div class="header-tools">
        <Menu class="menu" mode="horizontal" :theme="theme" :active-name="activeName" @on-select="linkTo">
          <MenuItem name="Platfrom">AI机器人</MenuItem>
          <MenuItem name="Chat">对话体验</MenuItem>
          <MenuItem name="Scene">应用场景</MenuItem>
          <!--<MenuItem name="Products">图灵精品之家</MenuItem>-->
          <MenuItem name="About">关于图灵</MenuItem>
        </Menu>
        <section class="login">
          <span class="btn backOrigin">
            <a href="http://www.tuling123.com/sso-web/index.html?ReturnURL=http%3A%2F%2Fwww.tuling123.com%2Fmember%2Frobot%2Findex.jhtml" onclick="_czc.push(['_trackEvent', '注册/登录', '点击', '注册登录按钮','1','login']);">
              <Button type="ghost" shape="circle" class="backOld">注册/登录</Button>
            </a>
            <span class="hover-info" style="border-radius: 8px;"><i class="triangle"></i>支持机器人APIkey创建</span>
          </span>
          <!--<span class="btn">-->
            <!--<Button type="ghost" shape="circle" class="loginBtn" @click="login"><a href="#">新平台体验版</a></Button>-->
            <!--<div class=" hover-info loginHead" v-if="this.token && userInfo.mobile !== ''">-->
              <!--<i class="triangle"></i>-->
              <!--<img class="ava-img" :src="userInfo.avatar"  @click="linkrobot">-->
              <!--<span class="name"  @click="linkrobot">{{userInfo.username}}</span>-->
              <!--<span class="name back" @click="back">退出</span>-->
            <!--</div>-->
            <!--<span class="hover-info" v-else><i class="triangle"></i>使用微信注册登录<br/>支持H5页面机器人创建</span>-->
          <!--</span>-->
        </section>
      </div>
    </section>
  </div>
</template>
<script>
import { SET_USERINFO } from '@/store/modules/publicinfo/mutation-types'
export default {
  name: 'TlBannerTop',
  data () {
    return {
      theme: 'light',
      activeName: '',
      loginUrl: 'http://www.tuling123.com/sso-web/index.html?ReturnURL=http%3A%2F%2Fwww.tuling123.com%2Fmember%2Frobot%2Findex.jhtml'
    }
  },
  created () {
    let actName = this.$route.name
    this.activeName = actName.substr(0, 1).toUpperCase() + actName.slice(1)
  },
  watch: {
    '$route' (to, from) {
      this.activeName = to.name
    }
  },
  computed: {
    topShow () {
      return this.$store.state.Home.topbarShow
    },
    url () {
      if (process.env.NODE_ENV !== 'production') {
        return encodeURIComponent('http://www.beta.turingapi.com/loading')
      } else {
        return encodeURIComponent('http://www.turingapi.com/loading')
      }
    },
    appId () {
      return process.env.APP_ID
    },
    code () {
      return this.$route.query.code
    },
    token () {
      if (JSON.parse(localStorage.getItem('turingToken'))) {
        return JSON.parse(localStorage.getItem('turingToken')).data
      } else {
        return null
      }
    },
    userInfo () {
      return this.$store.state.Publicinfo.userinfo
    }
  },
  methods: {
    linkTo (name) {
      this.$router.push({name})
      let label = ''
      if (name === 'Platfrom') {
        label = '机器人页面'
      } else if (name === 'Chat') {
        label = '体验区页面'
      } else if (name === 'Scene') {
        label = '应用场景页面'
      } else if (name === 'About') {
        label = '关于图灵页面'
      }
      if (window._czc) {
        window._czc.push(['_trackEvent', '按钮', '点击', label, '1', name])
      }
    },
    login () {
      if (!this.token && typeof (this.token) !== 'undefined' && this.token !== 0) {
        window.location = `https://open.weixin.qq.com/connect/qrconnect?appid=${this.appId}&redirect_uri=${this.url}&response_type=code&scope=snsapi_login#wechat_redirect`
      } else {
        if (this.userInfo.mobile) {
          this.$router.push({
            name: 'Robot'
          })
        } else {
          this.$router.push({
            name: 'Login'
          })
        }
      }
    },
    linkrobot () {
      this.$router.push({
        name: 'Robot'
      })
    },
    back () {
      window.location = window.location
      localStorage.removeItem('turingToken')
      setTimeout(() => {
        this.$store.commit(SET_USERINFO, {})
      }, 20)
    }
  }
}
</script>
<style lang="less" scoped>
  #bannerTop {
    width: 100%;
    height: 80px;
    background:#fff;
    .header-warp {
      height: 80px;
      min-width: 1000px;
      margin:0 auto;
      .logo {
        float: left;
        margin: 20px 0 0 120px;
        .logoImg {
          display: inline-block;
          width: 115px;
          height: 40px;
          background: url(../../assets/images/logob.png) no-repeat;
        }
      }
      .header-tools {
        float: right;
        height: 80px;
        margin-right: 120px;
        .menu {
          float:left;
          margin-top: 10px;
        }
        .ivu-menu-light:after {
          height: 0;
        }
        .login {
          float: left;
          line-height: 80px;
          .loginHead {
            display: inline-block;
            img {
              width: 36px;
              height: 36px;
              border-radius: 50%;
              margin: 0 10px;
              cursor: pointer;
              vertical-align: middle;
            }
            .name {
              cursor: pointer;
              max-width: 120px;
              overflow: hidden;
              text-overflow:ellipsis;
              white-space: nowrap;
              vertical-align: middle;
            }
          }
          .loginBtn {
            border:none;
            color: #2598D6;
            a {
              display: inline-block;
              width: 100%;
              height: 100%;
            }
          }
          .loginBtn:hover, .backOld:hover {
            background: RGBA(37, 152, 214, 0.2);
          }
          .backOld {
            border: 1px solid rgba(37, 152, 214, 0.5);
            opacity: 0.8;
            margin:0 20px 0 40px;
            a {
              display: inline-block;
              width: 100%;
              height: 100%;
            }
            i {
              display: inline-block;
              width: 15px;
              height: 12px;
              background:url(../../assets/images/backold1.png) no-repeat;
              vertical-align: middle;
              margin-right:5px;
            }
          }
        }
        .login {
          float: left;
          line-height: 80px;
          .backOrigin {
            margin: 0 20px 0 40px;
          }
          .btn {
            position: relative;
            height: 32px;
            .hover-info {
              transition: all 0.8s ease;
              opacity: 0;
              width: 180px;
              position: absolute;
              top: 52px;
              left: 50%;
              margin-left: -80px;
              display: inline-block;
              padding: 6px 15px;
              font-size: 14px;
              background:rgba(37, 152, 214, 0.5);
              color:#2598D6;
              line-height: 18px;
              border-radius: 10px;
              .triangle {
                position: absolute;
                top: -7px;
                left: 50%;
                margin-left: -5px;
                display: inline-block;
                width: 11px;
                height: 7px;
                background: url(../../assets/images/innerImg/triangle2.png) no-repeat;
                background-size: 100% 100%;
              }
            }
          }
          .btn:hover {
            .hover-info {
              opacity: 1;
              background:rgba(37, 152, 214, 0.2);
            }
          }
          .loginBtn {
            border: none;
            opacity: 0.8;
          }
          .loginBtn:hover {
            background:rgba(37, 152, 214, 0.2);
          }
          .loginHead {
            display: inline-block;
            padding: 0 10px!important;
            width: 226px!important;
            height: 30px!important;
            position: absolute;
            left: 50%;
            margin-left: -113px!important;
            top: 52px!important;
            background: rgba(37, 152, 214, 0.5);
            border-radius: 8px;
            line-height: 30px!important;
            img {
              width: 26px;
              height: 26px;
              border-radius: 50%;
              margin: 0 10px;
              cursor: pointer;
              vertical-align: middle;
              position: absolute;
              top: 2px;
              left: 10px;
            }
            .name {
              display: inline-block;
              max-width: 100px;
              overflow: hidden;
              text-overflow:ellipsis;
              white-space: nowrap;
              color: #2598D6;
              cursor: pointer;
              vertical-align: middle;
              font-size: 14px;
              line-height: 30px;
              position: absolute;
              left: 60px;
            }
            .back {
              left: auto;
              right: 20px;
              text-decoration: underline;
            }
            .hover-info {
              cursor: pointer;
              transition: all 0.8s ease;
              opacity: 0;
              width: 80px;
              position: absolute;
              top: 61px;
              left: 50%;
              margin-left: -40px;
              display: inline-block;
              padding: 6px 15px;
              font-size: 14px;
              background: rgba(37, 152, 214, 0.5);
              color:#2598D6;
              line-height: 18px;
              border-radius: 10px;
              text-align: center;
            }
          }
          .loginHead:hover {
            .hover-info {
              opacity: 1;
              background:rgba(37, 152, 214, 0.2);
            }
          }
          .backOld {
            opacity: 0.8;
            border:1px solid rgba(37, 152, 214, 0.5);
            i {
              display: inline-block;
              width: 15px;
              height: 12px;
              background:url(../../assets/images/backold2.png) no-repeat;
              vertical-align: middle;
              margin-right:5px;
            }
          }
          .backOld:hover {
            background:rgba(37, 152, 214, 0.2);
          }
          a {
            color: #2598D6;
          }
          .ivu-btn-ghost {
            color: #2598D6;
          }
        }
      }
    }
    &.active {
      position: fixed;
      top:0;
      left:0;
      z-index: 99;
    }
  }
  @media (max-width: 1000px) {
    #bannerTop {
      .header-warp {
        .logo {
          margin: 20px 0 0 83px;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/head/banner-top.vue